import React, { useEffect, useState } from "react";
import { Card, Spinner } from "reactstrap";
import { Col, Row } from "../../../../../../components/Component";
import StepGuideCard from "../../wizard_steps_guide/StepGuide";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import * as app_consts from "../../../../../../constants/react_app_consts";
import { employee_dashboard_actions_helper } from "../../../../../../actions/actions_helper";
import { messageToast } from "../../../../../../utils/Utils";

import FinalDetailsStep from "./steps/create_physical_delivery_note_ticket_steps/FinalDetailsStep";
import SelectLoadingOrdersStep from "./steps/create_physical_delivery_note_ticket_steps/SelectLoadingOrdersStep";
import AddProductsStep from "./steps/create_physical_delivery_note_ticket_steps/AddProductsStep";
import DeliveryNotePDFStep from "./steps/create_physical_delivery_note_ticket_steps/DeliveryNotePDFStep";

import {
  CONTINUE_PROCESSING_DELIVERY_NOTE_ACCESS_DENIED_MSG,
  CONTINUE_PROCESSING_DELIVERY_NOTE_ERR_MSG,
  CONTINUE_PROCESSING_DELIVERY_NOTE_SUCCESS_MSG,
} from "../../../../../../constants/success_error_messages_consts";
import { CONTINUE_PROCESSING_DELIVERY_NOTE_API } from "../../../../../../api/api_data";
import {
  fail_continue_processing_delivery_note,
  loading_continue_processing_delivery_note,
  reset_continue_processing_delivery_note,
  success_continue_processing_delivery_note,
} from "../../../../../../reducers/dashboard_reducers/delivery_notes/continue_processing_delivery_note_Slice";
import { resolveWeighbridgeTicketPrefillData } from "../../../../../../utils/weighbridgeTicketNormalization";

const intial_weigh_bridge_form_data = {
  consigner_type_id: "",
  user_account_id: "",
  user_account_label: "",
  weigh_bridge_ticket_type_id: "2",
  ticket_type: "Physical",
  property_ref_code: "",
  property_name: "",
  property_physical_address: "",
  truck_driver_id: "",
  truck_id: "",
  truck_trailer_id_one: "",
  first_weight: "",
  truck_driver: "",
  truck_license_plate: "",
  trailer_1: "",
  trailer_2: "",
  weighbridge_ticket_id: "",
  weigh_bridge_ticket_number: "",
  weigh_bridge_ticket_reference_no: "",
  truck_driver_name: "",
  transporter_name: "",
  trailer_one: "",
  trailer_two: "",
  comments: "",
  second_weight: "",
  net_weight: "",
  weighbridge_ticket_data: null,
  weighbridge_locked: false,
};

const CreatePhsyicalDeliveryNoteIndex = ({ wizardType, selectedWeighbridgeTicket }) => {
  const { delivery_note_ref_number } = useParams();
  const [step, setStep] = useState(1);
  const [wizardData, setWizardData] = useState([]);
  const dispatch = useDispatch();

  const [weighBridgeFormData, setWeighBridgeFormData] = useState(intial_weigh_bridge_form_data);
  const [continue_processing_data, setContinueProcessingData] = useState([]);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  // ======================================================
  // Continue processing (unchanged)
  // ======================================================
  useEffect(() => {
    if (delivery_note_ref_number) {
      setLoading(true);
      dispatch(
        employee_dashboard_actions_helper(
          loading_continue_processing_delivery_note,
          success_continue_processing_delivery_note,
          fail_continue_processing_delivery_note,
          CONTINUE_PROCESSING_DELIVERY_NOTE_ERR_MSG,
          CONTINUE_PROCESSING_DELIVERY_NOTE_SUCCESS_MSG,
          app_consts.POST,
          CONTINUE_PROCESSING_DELIVERY_NOTE_API,
          { delivery_note_ref_number: delivery_note_ref_number },
          CONTINUE_PROCESSING_DELIVERY_NOTE_ACCESS_DENIED_MSG
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const continue_processing_delivery_note = useSelector(
    (state) => state.continue_processing_delivery_note.continue_processing_delivery_note
  );

  useEffect(() => {
    if (continue_processing_delivery_note.status !== app_consts.IDLE) {
      if (continue_processing_delivery_note.status === app_consts.LOADING) {
        setError("");
        setLoading(true);
      } else {
        setLoading(false);

        if (continue_processing_delivery_note.status === app_consts.FAIL) {
          setError(continue_processing_delivery_note.message);
          messageToast(continue_processing_delivery_note.message, app_consts.FAIL);
        } else if (continue_processing_delivery_note.status === app_consts.SUCCESS) {
          setWeighBridgeFormData((prev) => ({
            ...prev,
            user_account_label: continue_processing_delivery_note.data?.user_account,
          }));
          setStep(continue_processing_delivery_note.data?.step);
          setContinueProcessingData(continue_processing_delivery_note.data?.delivery_note_data);
          setWizardData(continue_processing_delivery_note.data?.delivery_note_data);
        }

        dispatch(reset_continue_processing_delivery_note());
      }
    }
  }, [continue_processing_delivery_note, dispatch]);

  // ======================================================
  // SAFE: store selected ticket into weighBridgeFormData
  // (does not affect continue processing)
  // ======================================================
  useEffect(() => {
    if (!selectedWeighbridgeTicket) return;
    if (delivery_note_ref_number) return;

    const selectedTicketPrefill =
      resolveWeighbridgeTicketPrefillData(selectedWeighbridgeTicket);

    const selectedTicketId =
      selectedTicketPrefill?.weighbridge_ticket_id ||
      selectedWeighbridgeTicket?.weighbridge_ticket_id ||
      selectedWeighbridgeTicket?.weigh_bridge_ticket_id ||
      selectedWeighbridgeTicket?.id ||
      "";

    if (String(weighBridgeFormData?.weighbridge_ticket_id || "") === String(selectedTicketId)) return;

    setWeighBridgeFormData((prev) => ({
      ...prev,
      weighbridge_ticket_id: selectedTicketId,
      weigh_bridge_ticket_number:
        selectedTicketPrefill?.weigh_bridge_ticket_number ||
        selectedWeighbridgeTicket?.weigh_bridge_ticket_number ||
        selectedWeighbridgeTicket?.ticket_number ||
        prev.weigh_bridge_ticket_number,
      weigh_bridge_ticket_reference_no:
        selectedTicketPrefill?.weigh_bridge_ticket_reference_no ||
        selectedWeighbridgeTicket?.weigh_bridge_ticket_reference_no ||
        prev.weigh_bridge_ticket_reference_no,
      truck_license_plate:
        selectedTicketPrefill?.truck_licence_plate ||
        selectedWeighbridgeTicket?.truck_licence_plate ||
        selectedWeighbridgeTicket?.vehicle_number ||
        prev.truck_license_plate,
      truck_licence_plate:
        selectedTicketPrefill?.truck_licence_plate ||
        selectedWeighbridgeTicket?.truck_licence_plate ||
        selectedWeighbridgeTicket?.vehicle_number ||
        prev.truck_licence_plate,
      truck_driver_name:
        selectedTicketPrefill?.truck_driver_name ||
        selectedWeighbridgeTicket?.truck_driver_name ||
        prev.truck_driver_name,
      transporter_name:
        selectedTicketPrefill?.transporter_name ||
        selectedWeighbridgeTicket?.transporter_name ||
        prev.transporter_name,
      trailer_one:
        selectedTicketPrefill?.trailer_one ||
        selectedWeighbridgeTicket?.trailer_one ||
        prev.trailer_one,
      trailer_two:
        selectedTicketPrefill?.trailer_two ||
        selectedWeighbridgeTicket?.trailer_two ||
        prev.trailer_two,
      comments:
        selectedTicketPrefill?.comments ||
        selectedWeighbridgeTicket?.comments ||
        prev.comments,
      first_weight:
        selectedWeighbridgeTicket?.first_weight ||
        selectedTicketPrefill?.first_weight ||
        prev.first_weight,
      second_weight:
        selectedWeighbridgeTicket?.second_weight ||
        selectedTicketPrefill?.second_weight ||
        prev.second_weight,
      net_weight:
        selectedWeighbridgeTicket?.net_weight ||
        selectedTicketPrefill?.net_weight ||
        prev.net_weight,
      weighbridge_ticket_data:
        selectedWeighbridgeTicket ||
        selectedTicketPrefill?.weighbridge_ticket_data,
      weighbridge_locked: true,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWeighbridgeTicket, delivery_note_ref_number]);

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  // ======================================================
  // SAFE: pick best available PDF data
  // - continue_processing_data first (backend flow)
  // - otherwise fallback to wizardData (create flow)
  // ======================================================
  const pdfData = (continue_processing_data && Object.keys(continue_processing_data).length > 0)
    ? continue_processing_data
    : wizardData;

  return (
    <>
      {loading ? (
        <div className="w-full p-5 d-flex justify-center items-center">
          <Spinner />
        </div>
      ) : error && error.length > 0 ? (
        <div className="text-soft alert-icon w-full p-5 d-flex justify-center items-center fw-bold fs-18px">
          {error}
        </div>
      ) : (
        <Card className="card-bordered">
          <Row className="g-0 col-sep col-sep-md col-sep-xl">
            <StepGuideCard
              sentStep={step}
              wizard_type={wizardType}
              wizard_title={"Create Physical Delivery Note"}
            />

            <Col className="col-md-8 col-xl-8">
              {step === 1 ? (
                <SelectLoadingOrdersStep
                  nextStep={nextStep}
                  setWizardData={setWizardData}
                  setWeighBridgeFormData={setWeighBridgeFormData}
                  selectedWeighbridgeTicket={selectedWeighbridgeTicket}
                />
              ) : step === 2 ? (
                <AddProductsStep
                  nextStep={nextStep}
                  setWizardData={setWizardData}
                  wizardData={wizardData}
                  setContinueProcessingData={setContinueProcessingData}
                  weighBridgeFormData={weighBridgeFormData}
                />
              ) : step === 3 ? (
                <FinalDetailsStep
                  weighBridgeFormData={weighBridgeFormData}
                  nextStep={nextStep}
                  continue_processing_data={continue_processing_data}
                  setContinueProcessingData={setContinueProcessingData}
                  selectedWeighbridgeTicket={selectedWeighbridgeTicket}
                />
              ) : step === 4 ? (
                <DeliveryNotePDFStep
                  continue_processing_data={pdfData}
                  nextStep={nextStep}
                  weighBridgeFormData={weighBridgeFormData}
                  wizardData={wizardData}
                />
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};

export default CreatePhsyicalDeliveryNoteIndex;
